import Component from './component';

Component.defaultProps = {
    onSuccess: null,
    token: null,
    viewActivatePatient: false,
};
export default Component;
